import React, { Component } from "react";
import axios from "axios";
import { SegmentedItem, TableItemDinamico, dineroDisabledMask, ButtonItem } from "../../../Components/Items";
import { message, PageHeader, Space, Tag, Tooltip } from "antd";
import { connect } from "react-redux";
import { CloseCircleOutlined, EyeOutlined, BookFilled } from "@ant-design/icons";
import moment from "moment";
import MandarCorreoFacturaGlobal from "../Ventas/MandarCorreoFacturaGlobal/MandarCorreoFacturaGlobal";
import ModalVentasRelacionadas from "./ModalVentasRelacionadas/ModalVentasRelacionadas";
import CancelarFacturaGlobal from "../Ventas/CancelarFacturaGlobal/CancelarFacturaGlobal";
moment.locale("es");

class FacturasGlobales extends Component {
    tableRef = null;
    state = {
        todasFacturasGlobales: [],
        loading: false,
        totalRecords: 0,
        valor: 2,
        modalVerFacturaGlobal: false,
        modalVerFacturaGlobalId: null,
        isVentasModalVisible: false,
        selectedVentasIds: [],
        modalCancelacion: false,
        modalCancelacionId: null,

    }

    consultarFacturasGlobales = (params) => {
        this.setState({ loading: true });

        axios
            .post(
                "facturasGlobales/selectFacturasGlobalesPorEmpresa",
                { empresaId: this.props.empresaId, ...params },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.setState({
                        todasFacturasGlobales: res.data.data.map((value) => {
                            let numero = '';
                            if (value.facturaSerie || value.facturaNumero) {
                                numero += (value.facturaSerie || 'FG') + ' - ' + (value.facturaNumero || '');
                            }

                            let proyecto = value.proyecto ? value.proyecto.nombre : '';

                            return {
                                ...value,
                                numero: numero.trim(),
                                descripcionPeriodo: value.descripcionPeriodo || '',
                                //cliente: nombreCliente.trim(),
                                fechaFactura: value.fechaFactura
                                    ? moment(value.fechaFactura).toDate() // Usa fechaFactura si existe
                                    : (value.createdAt ? moment(value.createdAt).toDate() : null),
                                proyecto: proyecto,
                                accion: {
                                    _id: value._id,
                                    estado: value.estado,
                                    ventasIds: value.ventasIds || []
                                },
                            };
                        }),
                        totalRecords: res.data.totalRecords || 0,
                        loading: false
                    });
                } else {
                    this.setState({ todasFacturasGlobales: [], totalRecords: 0, loading: false });

                }
            })
            .catch((err) => {
                this.setState({ loading: false });
                message.error("Error al consultar las facturas globales");
                console.log(err);
            });
    }


    //Funciones para el modal de ver PDF de factura global
    verFacturaGlobal(facturaGlobalId) {
        this.setState({
            modalVerFacturaGlobal: true,
            modalVerFacturaGlobalId: facturaGlobalId,
        });
    }

    cerrarMandarCorreoFacturaGlobal = () => {
        this.setState({
            modalVerFacturaGlobal: false,
            modalVerFacturaGlobalId: null,
        });
    }
    //Funciones para el modal de ver ventas relacionadas
    verVentasModal = (ventasIds) => {
        this.setState({
            isVentasModalVisible: true,
            selectedVentasIds: ventasIds,
        });
    };

    cerrarVentasModal = () => {
        this.setState({
            isVentasModalVisible: false,
            selectedVentasIds: [],
        });
    };

    cerrarCancelarFacturaGlobal() {
        this.setState({
            modalCancelacion: false,
        });
        this.consultarFacturasGlobales();
    }
    render() {
        const columns = [
            {
                title: "F/R",
                dataIndex: "numero",
                key: "numero",
                buscar: 'numero',
                width: "12%",
            },
            {
                title: "Descripción Periodo",
                dataIndex: "descripcionPeriodo",
                key: "descripcionPeriodo",
                width: "16%",
                buscar: 'descripcionPeriodo',
                ellipsis: true,
            },
            {
                title: "Proyecto",
                dataIndex: "proyecto",
                key: "proyecto",
                width: "16%",
                buscar: 'proyecto',
                ellipsis: true,
            },
            {
                title: "Fecha",
                dataIndex: "fechaFactura",
                key: "fechaFactura",
                defaultSortOrder: 'descend',
                sorter: true,
                render: (value) => moment(value).locale("es").format("DD/MM/YY HH:mm"),
                width: "10%",
                ellipsis: true,
                align: "center",
            },
            {
                title: "Subtotal / Total",
                dataIndex: "subtotal",
                key: "subtotal",
                responsive: ["md"],
                sorter: true,
                buscar: "subtotal",
                render: (_, record) => (
                    <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "12px", color: "#666" }}>
                            {dineroDisabledMask(record.subtotal)} {record.moneda}
                        </div>
                        <div style={{ fontWeight: "bold", fontSize: "12px" }}>
                            {dineroDisabledMask(record.total)} {record.moneda}
                        </div>
                    </div>
                ),
                width: "12%",
                ellipsis: true,
                align: "right",
            },
            {
                title: "Total",
                dataIndex: "total",
                key: "total",
                sorter: true,
                buscar: "total",
                responsive: [],
                width: 0,
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                responsive: ["md"],
                render: (value, record) => {
                    if (value === 0) {
                        return <Tag color="red" className="square-tag">Cancelada</Tag>;

                    }
                    if (value === 1) {
                        return <Tag color="green" className="square-tag">Vigente</Tag>;
                    }

                },
                width: "10%",
                ellipsis: true,
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                fixed: window.innerWidth > 1200 ? "right" : null,
                width: "16%",
                align: "center",
                onCell: () => ({
                className: "acciones-sin-hover",
                }),

                render: (value, index) => {
                    if (value.estado === 0) return;
                    let buttons = [];

                    buttons.push(
                        <Tooltip title="Ver PDF" placement="top">
                            <ButtonItem
                                key={`ver-pdf-${value._id}`}
                                type="default"
                                size="small"
                                lila
                                icon={<BookFilled />}
                                onClick={() => this.verFacturaGlobal(value._id)}
                            >
                            </ButtonItem>
                        </Tooltip>
                    );

                    if (value.ventasIds.length > 0) {
                        buttons.push(
                            <Tooltip title="Ver Ventas" placement="top">
                                <ButtonItem
                                    key={`ver-ventas-${index}`}
                                    type="default"
                                    size="small"
                                    cyan
                                    icon={<EyeOutlined />}
                                    onClick={() => {
                                        const ids = value.ventasIds.map(item => item.ventaId);
                                        this.verVentasModal(ids);
                                    }}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    if (value.estado !== 0) {
                        buttons.push(
                            <Tooltip title="Cancelar" placement="top">
                                <ButtonItem
                                    key={`cancelar-${index}`}
                                    type="default"
                                    size="small"
                                    rojo
                                    icon={<CloseCircleOutlined />}
                                    onClick={() => {
                                        this.setState({ modalCancelacion: true, modalCancelacionId: value._id })
                                    }}
                                >
                                </ButtonItem>
                            </Tooltip>
                        );
                    }

                    return <Space direction="horizontal">{buttons}</Space>;
                },
            },
        ];
        return (
            <>
                <PageHeader
                    title="Facturas Globales"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <div className="header-actions">
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Todos', value: 2 }, { label: 'Vigentes', value: 1 }, { label: 'Cancelados', value: 0 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value });
                                            }
                                            this.setState({ valor: value });
                                        }}

                                        value={this.state.valor}
                                    />
                                    <div className="header-divider"></div>
                                </>
                            }
                        </div>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    /*onRow={(record, rowIndex) => {
                        return {
                            onDoubleClick: (event) => {
                                this.props.history.push("/panel/verVenta", { id: record._id });
                            },
                        };
                    }}*/
                    anadirValorFiltro={this.state.valor}
                    onFetchData={this.consultarFacturasGlobales.bind(this)}
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.todasFacturasGlobales}
                    columns={columns}
                    filterStorageKey={"facturasGlobalesFiltros" + this.props.empresaId}
                    pagination={false}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={2}
                />
                <MandarCorreoFacturaGlobal
                    visible={this.state.modalVerFacturaGlobal}
                    id={this.state.modalVerFacturaGlobalId}
                    history={this.props.history}
                    cerrarMandarCorreoFacturaGlobal={this.cerrarMandarCorreoFacturaGlobal} // Usamos la nueva función
                />
                <ModalVentasRelacionadas
                    visible={this.state.isVentasModalVisible}
                    onClose={this.cerrarVentasModal}
                    ventasIds={this.state.selectedVentasIds}
                    history={this.props.history} // Pasa el historial para la navegación
                />
                <CancelarFacturaGlobal
                    visible={this.state.modalCancelacion}
                    id={this.state.modalCancelacionId}
                    cerrarCancelarFacturaGlobal={this.cerrarCancelarFacturaGlobal.bind(this)}
                />
            </>
        );



    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        permisoFacturaGlobal:
            state.user.tipo === 0 ||
            state.user.permisos.find(
                (valueTodos) =>
                    valueTodos.permisoId.toString() === "6750916e798d4e0043687240"
            )?.activado,
    };
};

export default connect(mapStateToProps)(FacturasGlobales);
